import { GetServerSideProps } from "next"
import { NovelViewerPage } from "../../../../../components/pages/novel/NovelViewer"

export const getServerSideProps: GetServerSideProps = async ({ query }) => {
  if (
    typeof query.novelId !== "string" ||
    typeof query.chapterId !== "string"
  ) {
    return { notFound: true }
  }

  const novelId = parseInt(query.novelId)
  const chapterId = parseInt(query.chapterId)

  if (!Number.isSafeInteger(novelId) || !Number.isSafeInteger(chapterId)) {
    return { notFound: true }
  }

  return {
    props: {
      novelId: novelId,
      chapterId: chapterId,
    },
  }
}

type Props = {
  novelId: number
  chapterId: number
}

const NovelViewer = ({ novelId, chapterId }: Props): JSX.Element => {
  return <NovelViewerPage novelId={novelId} chapterId={chapterId} />
}

export default NovelViewer
